import { combineReducers } from "redux";
import sharedReducer from "./shared.reducer";

export default combineReducers({
    sharedReducer
})